import { detectAdminLocale } from "./index";
import { appMessages } from "./app";

export const translateApp = (key: string): string => {
  const locale = detectAdminLocale();
  const parts = key.split(".");
  let node: unknown = appMessages[locale];
  for (const part of parts) {
    if (!node || typeof node !== "object") return key;
    node = (node as Record<string, unknown>)[part];
  }
  return typeof node === "string" ? node : key;
};
